const tourLanguagesEndpoints = {
  base: "/v1/cms/tour-languages",
  byTourId: (tourId) =>
    `/v1/cms/tour-languages/${encodeURIComponent(String(tourId || ""))}`,
};

export default tourLanguagesEndpoints;
